const React = require('react');
const { Link } = require('react-router-dom');

const PropTypes = require('prop-types');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @components
const BrokerLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/brokerLegalConfirmation');

class BrokerStockContractLegalText extends React.Component {

    componentDidMount(){
        const { onResolvedDependencies } = this.props;
        onResolvedDependencies(true);
    }

    buildLegalDisclaimerProductDescription() {
        const { contractServicesIndividuals } = this.props;
        const legalDocumentMessageBoldText = formatText('brokerStockContractLegalText-legalDocumentMessageBoldText');
        const tacText2 = formatText('broker-stocksContractTACText2');
        const tacText4 = formatText('broker-stocksContractTACText4');

        const links = [
            <Link
                to="/myprofile/broker/preContractInfo"
                className="ok-link"
                key="0"
            >
                {tacText2}
            </Link>,
            <Link
                to={contractServicesIndividuals}
                target="_blank"
                className="ok-link"
                key="1"
            >
                {tacText4}
            </Link>
        ];

        return(
            <div>
                <p>{legalDocumentMessageBoldText}</p>
                <FormattedTextWithComponents
                    value="brokerStockContractLegalText-linksDisclaimer"
                    injectedComponents={links}
                />
            </div>
        )
    }

    buildLegalDisclaimerQuestion() {
        const { immProfileFields } = this.props;
        const userName = PersonalDataHelper.getFullName(immProfileFields);
        const legalDisclaimerQuestionOne = formatText('brokerStockContractLegalText-disclaimerYesNoQuestionOne');
        const legalDisclaimerQuestionTwo = formatText('brokerStockContractLegalText-disclaimerYesNoQuestionTwo', [userName]);

        return(
            <div>
                <p>{legalDisclaimerQuestionOne}</p>
                <p>{legalDisclaimerQuestionTwo}</p>
            </div>
        )
    }

    render() {
        const {
            sendMail,
            immProfileFields,
            immPreContractualMail,
            requestProfile,
            resetEmailInfo,
            onYesNoOptionChange,
            selectedYesNoOption,
            sendMailParams
        } = this.props;


        const disclaimerNoAnswer = <FormattedText value="brokerStockContractLegalText-disclaimerNoAnswer"/>;
        const disclaimerYesAnswer = formatText('brokerStockContractLegalText-disclaimerYesAnswer');
        const refreshEmailError = immProfileFields.get('error') ? immProfileFields.getIn([ 'error', 'description' ], 'Error') : undefined;
        const email = PersonalDataHelper.getEmail(immProfileFields);
        const legalDisclaimerProductDescription = this.buildLegalDisclaimerProductDescription();
        const legalDisclaimerQuestion = this.buildLegalDisclaimerQuestion();

        return (
            <BrokerLegalConfirmation
                titleKey="brokerStockContractLegalText-stockContractLegalTitle"
                legalDisclaimerProductDescription={legalDisclaimerProductDescription}
                legalDisclaimerQuestion={legalDisclaimerQuestion}
                legalDisclaimerNoAnswer={disclaimerNoAnswer}
                legalDisclaimerYesAnswer={disclaimerYesAnswer}
                refreshEmailAddressError={refreshEmailError}
                clientEmailAddress={email}
                refreshEmailAddress={requestProfile}
                sendMail={sendMail}
                sendMailParams={sendMailParams}
                immPreContractualMail={immPreContractualMail}
                resetMailState={resetEmailInfo}
                onYesNoOptionChange={onYesNoOptionChange}
                selectedYesNoOption={selectedYesNoOption}
            />
        );
    }

}


BrokerStockContractLegalText.propTypes = {
    className: PropTypes.string,
    titleKey: PropTypes.string,
    refreshEmailAddressError: PropTypes.string,
    clientEmailAddress: PropTypes.string.isRequired,
    sendMail: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    resetMailState: PropTypes.func.isRequired,
    requestProfile: PropTypes.object.isRequired,
    resetEmailInfo: PropTypes.func.isRequired,
    selectedYesNoOption: PropTypes.string.isRequired,
    onYesNoOptionChange: PropTypes.func.isRequired,
    onResolvedDependencies: PropTypes.func,
    contractServicesIndividuals: PropTypes.string
}

module.exports = BrokerStockContractLegalText;

